import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`In a federated architecture, each of your graph's `}<a parentName="p" {...{
        "href": "/federation/subgraphs/"
      }}>{`subgraphs`}</a>{` uses the Rover CLI to register its schema with Apollo:`}</p>
    <p><div parentName="p" {...{
        "className": "mermaid"
      }}><svg parentName="div" {...{
          "aria-role-description": ["flowchart-v2"],
          "role": "graphics-document document",
          "viewBox": "-8 -8 839.125 288",
          "style": {
            "maxWidth": "839.125px"
          },
          "xmlns": "http://www.w3.org/2000/svg",
          "width": "100%",
          "id": "mermaid-0"
        }}><style parentName="svg">{`#mermaid-0{font-family:arial,sans-serif;font-size:16px;fill:#333;}#mermaid-0 .error-icon{fill:#552222;}#mermaid-0 .error-text{fill:#552222;stroke:#552222;}#mermaid-0 .edge-thickness-normal{stroke-width:2px;}#mermaid-0 .edge-thickness-thick{stroke-width:3.5px;}#mermaid-0 .edge-pattern-solid{stroke-dasharray:0;}#mermaid-0 .edge-pattern-dashed{stroke-dasharray:3;}#mermaid-0 .edge-pattern-dotted{stroke-dasharray:2;}#mermaid-0 .marker{fill:#333333;stroke:#333333;}#mermaid-0 .marker.cross{stroke:#333333;}#mermaid-0 svg{font-family:arial,sans-serif;font-size:16px;}#mermaid-0 .label{font-family:arial,sans-serif;color:#333;}#mermaid-0 .cluster-label text{fill:#333;}#mermaid-0 .cluster-label span,#mermaid-0 p{color:#333;}#mermaid-0 .label text,#mermaid-0 span,#mermaid-0 p{fill:#333;color:#333;}#mermaid-0 .node rect,#mermaid-0 .node circle,#mermaid-0 .node ellipse,#mermaid-0 .node polygon,#mermaid-0 .node path{fill:#ECECFF;stroke:#9370DB;stroke-width:1px;}#mermaid-0 .flowchart-label text{text-anchor:middle;}#mermaid-0 .node .label{text-align:center;}#mermaid-0 .node.clickable{cursor:pointer;}#mermaid-0 .arrowheadPath{fill:#333333;}#mermaid-0 .edgePath .path{stroke:#333333;stroke-width:2.0px;}#mermaid-0 .flowchart-link{stroke:#333333;fill:none;}#mermaid-0 .edgeLabel{background-color:#e8e8e8;text-align:center;}#mermaid-0 .edgeLabel rect{opacity:0.5;background-color:#e8e8e8;fill:#e8e8e8;}#mermaid-0 .labelBkg{background-color:rgba(232, 232, 232, 0.5);}#mermaid-0 .cluster rect{fill:#ffffde;stroke:#aaaa33;stroke-width:1px;}#mermaid-0 .cluster text{fill:#333;}#mermaid-0 .cluster span,#mermaid-0 p{color:#333;}#mermaid-0 div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:arial,sans-serif;font-size:12px;background:hsl(80, 100%, 96.2745098039%);border:1px solid #aaaa33;border-radius:2px;pointer-events:none;z-index:100;}#mermaid-0 .flowchartTitleText{text-anchor:middle;font-size:18px;fill:#333;}#mermaid-0 :root{--mermaid-font-family:arial,sans-serif;}`}</style><g parentName="svg"><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "12",
              "markerWidth": "12",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "6",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-pointEnd"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 0 0 L 10 5 L 0 10 z"
              }}></path></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "12",
              "markerWidth": "12",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "4.5",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-pointStart"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 0 5 L 10 10 L 10 0 z"
              }}></path></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "11",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-circleEnd"
            }}><circle parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "r": "5",
                "cy": "5",
                "cx": "5"
              }}></circle></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "-1",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-circleStart"
            }}><circle parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "r": "5",
                "cy": "5",
                "cx": "5"
              }}></circle></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5.2",
              "refX": "12",
              "viewBox": "0 0 11 11",
              "className": "marker cross flowchart",
              "id": "mermaid-0_flowchart-crossEnd"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "2",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 1,1 l 9,9 M 10,1 l -9,9"
              }}></path></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5.2",
              "refX": "-1",
              "viewBox": "0 0 11 11",
              "className": "marker cross flowchart",
              "id": "mermaid-0_flowchart-crossStart"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "2",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 1,1 l 9,9 M 10,1 l -9,9"
              }}></path></marker><g parentName="g" {...{
              "className": "root"
            }}><g parentName="g" {...{
                "className": "clusters"
              }}><g parentName="g" {...{
                  "id": "subGraph0",
                  "className": "cluster default flowchart-label"
                }}><rect parentName="g" {...{
                    "height": "272",
                    "width": "366.171875",
                    "y": "0",
                    "x": "0",
                    "ry": "0",
                    "rx": "0",
                    "style": {}
                  }}></rect><g parentName="g" {...{
                    "transform": "translate(183.0859375, 0)",
                    "className": "cluster-label"
                  }}><foreignObject parentName="g" {...{
                      "height": "0",
                      "width": "0"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "nodeLabel"
                        }}></span></div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "edgePaths"
              }}><path parentName="g" {...{
                  "style": {
                    "fill": "none"
                  },
                  "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-gateway LE-serviceA",
                  "id": "L-gateway-serviceA-0",
                  "d": "M86.684,119L96.268,107.833C105.852,96.667,125.02,74.333,139.382,63.167C153.745,52,163.302,52,168.081,52L172.859,52"
                }}></path><path parentName="g" {...{
                  "style": {
                    "fill": "none"
                  },
                  "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-gateway LE-serviceB",
                  "id": "L-gateway-serviceB-0",
                  "d": "M119.188,136L123.354,136C127.521,136,135.854,136,145.104,136C154.354,136,164.521,136,169.604,136L174.688,136"
                }}></path><path parentName="g" {...{
                  "style": {
                    "fill": "none"
                  },
                  "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-gateway LE-serviceC",
                  "id": "L-gateway-serviceC-0",
                  "d": "M86.684,153L96.268,164.167C105.852,175.333,125.02,197.667,138.77,208.833C152.521,220,160.854,220,165.021,220L169.188,220"
                }}></path><path parentName="g" {...{
                  "markerEnd": "url(#mermaid-0_flowchart-pointEnd)",
                  "style": {
                    "fill": "none",
                    "strokeWidth": "2px",
                    "strokeDasharray": "3"
                  },
                  "className": "edge-thickness-normal edge-pattern-dotted flowchart-link LS-serviceA LE-registry",
                  "id": "L-serviceA-registry-0",
                  "d": "M337.5,52L342.279,52C347.057,52,356.615,52,381.008,52C405.401,52,444.63,52,493.872,62.944C543.115,73.888,602.37,95.776,631.997,106.72L661.625,117.664"
                }}></path><path parentName="g" {...{
                  "markerEnd": "url(#mermaid-0_flowchart-pointEnd)",
                  "style": {
                    "fill": "none",
                    "strokeWidth": "2px",
                    "strokeDasharray": "3"
                  },
                  "className": "edge-thickness-normal edge-pattern-dotted flowchart-link LS-serviceB LE-registry",
                  "id": "L-serviceB-registry-0",
                  "d": "M335.672,136L340.755,136C345.839,136,356.005,136,380.703,136C405.401,136,444.63,136,483.059,136.08C521.489,136.159,559.118,136.318,577.932,136.398L596.747,136.478"
                }}></path><path parentName="g" {...{
                  "markerEnd": "url(#mermaid-0_flowchart-pointEnd)",
                  "style": {
                    "fill": "none",
                    "strokeWidth": "2px",
                    "strokeDasharray": "3"
                  },
                  "className": "edge-thickness-normal edge-pattern-dotted flowchart-link LS-serviceC LE-registry",
                  "id": "L-serviceC-registry-0",
                  "d": "M341.172,220L345.339,220C349.505,220,357.839,220,381.62,220C405.401,220,444.63,220,493.871,209.219C543.112,198.437,602.364,176.875,631.99,166.094L661.616,155.312"
                }}></path></g><g parentName="g" {...{
                "className": "edgeLabels"
              }}><g parentName="g" {...{
                  "className": "edgeLabel"
                }}><g parentName="g" {...{
                    "transform": "translate(0, 0)",
                    "className": "label"
                  }}><foreignObject parentName="g" {...{
                      "height": "0",
                      "width": "0"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "edgeLabel"
                        }}></span></div></foreignObject></g></g><g parentName="g" {...{
                  "className": "edgeLabel"
                }}><g parentName="g" {...{
                    "transform": "translate(0, 0)",
                    "className": "label"
                  }}><foreignObject parentName="g" {...{
                      "height": "0",
                      "width": "0"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "edgeLabel"
                        }}></span></div></foreignObject></g></g><g parentName="g" {...{
                  "className": "edgeLabel"
                }}><g parentName="g" {...{
                    "transform": "translate(0, 0)",
                    "className": "label"
                  }}><foreignObject parentName="g" {...{
                      "height": "0",
                      "width": "0"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "edgeLabel"
                        }}></span></div></foreignObject></g></g><g parentName="g" {...{
                  "transform": "translate(483.859375, 52)",
                  "className": "edgeLabel"
                }}><g parentName="g" {...{
                    "transform": "translate(-92.6875, -9.5)",
                    "className": "label"
                  }}><foreignObject parentName="g" {...{
                      "height": "19",
                      "width": "185.375"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "edgeLabel"
                        }}>{`rover subgraph publish`}</span></div></foreignObject></g></g><g parentName="g" {...{
                  "transform": "translate(483.859375, 136)",
                  "className": "edgeLabel"
                }}><g parentName="g" {...{
                    "transform": "translate(-92.6875, -9.5)",
                    "className": "label"
                  }}><foreignObject parentName="g" {...{
                      "height": "19",
                      "width": "185.375"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "edgeLabel"
                        }}>{`rover subgraph publish`}</span></div></foreignObject></g></g><g parentName="g" {...{
                  "transform": "translate(483.859375, 220)",
                  "className": "edgeLabel"
                }}><g parentName="g" {...{
                    "transform": "translate(-92.6875, -9.5)",
                    "className": "label"
                  }}><foreignObject parentName="g" {...{
                      "height": "19",
                      "width": "185.375"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "edgeLabel"
                        }}>{`rover subgraph publish`}</span></div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "nodes"
              }}><g parentName="g" {...{
                  "transform": "translate(72.09375, 136)",
                  "id": "flowchart-gateway-0",
                  "className": "node default default flowchart-label"
                }}><rect parentName="g" {...{
                    "height": "34",
                    "width": "94.1875",
                    "y": "-17",
                    "x": "-47.09375",
                    "ry": "17",
                    "rx": "17",
                    "style": {}
                  }}></rect><g parentName="g" {...{
                    "transform": "translate(-35.34375, -9.5)",
                    "style": {},
                    "className": "label"
                  }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                      "height": "19",
                      "width": "70.6875"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "nodeLabel"
                        }}>{`Gateway`}</span></div></foreignObject></g></g><g parentName="g" {...{
                  "transform": "translate(255.1796875, 52)",
                  "id": "flowchart-serviceA-1",
                  "className": "node default default flowchart-label"
                }}><rect parentName="g" {...{
                    "height": "34",
                    "width": "164.640625",
                    "y": "-17",
                    "x": "-82.3203125",
                    "ry": "0",
                    "rx": "0",
                    "style": {},
                    "className": "basic label-container"
                  }}></rect><g parentName="g" {...{
                    "transform": "translate(-74.8203125, -9.5)",
                    "style": {},
                    "className": "label"
                  }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                      "height": "19",
                      "width": "149.640625"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "nodeLabel"
                        }}>{`Products subgraph`}</span></div></foreignObject></g></g><g parentName="g" {...{
                  "transform": "translate(255.1796875, 136)",
                  "id": "flowchart-serviceB-2",
                  "className": "node default default flowchart-label"
                }}><rect parentName="g" {...{
                    "height": "34",
                    "width": "160.984375",
                    "y": "-17",
                    "x": "-80.4921875",
                    "ry": "0",
                    "rx": "0",
                    "style": {},
                    "className": "basic label-container"
                  }}></rect><g parentName="g" {...{
                    "transform": "translate(-72.9921875, -9.5)",
                    "style": {},
                    "className": "label"
                  }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                      "height": "19",
                      "width": "145.984375"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "nodeLabel"
                        }}>{`Reviews subgraph`}</span></div></foreignObject></g></g><g parentName="g" {...{
                  "transform": "translate(255.1796875, 220)",
                  "id": "flowchart-serviceC-3",
                  "className": "node default default flowchart-label"
                }}><rect parentName="g" {...{
                    "height": "34",
                    "width": "171.984375",
                    "y": "-17",
                    "x": "-85.9921875",
                    "ry": "0",
                    "rx": "0",
                    "style": {},
                    "className": "basic label-container"
                  }}></rect><g parentName="g" {...{
                    "transform": "translate(-78.4921875, -9.5)",
                    "style": {},
                    "className": "label"
                  }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                      "height": "19",
                      "width": "156.984375"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "nodeLabel"
                        }}>{`Inventory subgraph`}</span></div></foreignObject></g></g><g parentName="g" {...{
                  "transform": "translate(712.3359375, 136)",
                  "id": "flowchart-registry-4",
                  "className": "node default secondary flowchart-label"
                }}><polygon parentName="g" {...{
                    "style": {},
                    "transform": "translate(-110.7890625,17)",
                    "className": "label-container",
                    "points": "8.5,0 213.078125,0 221.578125,-17 213.078125,-34 8.5,-34 0,-17"
                  }}></polygon><g parentName="g" {...{
                    "transform": "translate(-94.7890625, -9.5)",
                    "style": {},
                    "className": "label"
                  }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                      "height": "19",
                      "width": "189.578125"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "nodeLabel"
                        }}>{`Apollo Schema Registry`}</span></div></foreignObject></g></g></g></g></g></svg></div></p>
    <p>{`If you haven't yet:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/rover/getting-started/"
        }}>{`Install the Rover CLI`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/rover/configuring/"
        }}>{`Authenticate Rover`}</a>{` with GraphOS Studio`}</li>
    </ul>
    <p>{`Then, `}<strong parentName="p">{`do the following for each of your subgraphs`}</strong>{`:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Obtain the following values, which are required for the `}<inlineCode parentName="p">{`rover subgraph publish`}</inlineCode>{` command:`}</p>
        <ul parentName="li">
          <li parentName="ul">{`The name that uniquely identifies the subgraph within your graph (e.g., `}<inlineCode parentName="li">{`products`}</inlineCode>{`).`}
            <ul parentName="li">
              <li parentName="ul">{`If you've already registered a particular subgraph at least once, you can get its name from your graph's `}<strong parentName="li">{`Schema > SDL`}</strong>{` tab in GraphOS Studio, or by running `}<inlineCode parentName="li">{`rover subgraph list`}</inlineCode>{`.`}</li>
              <li parentName="ul">{`Otherwise, you set the subgraph's name the first time you register it. `}<strong parentName="li">{`Make sure the name is unique within your graph.`}</strong></li>
            </ul>
          </li>
          <li parentName="ul">{`The URL that your gateway will use to communicate with the subgraph (e.g., `}<inlineCode parentName="li">{`http://products-graphql.svc.cluster.local:4001/`}</inlineCode>{`).`}</li>
          <li parentName="ul">{`The service's schema. The Rover CLI can either:`}
            <ul parentName="li">
              <li parentName="ul">{`Use a `}<inlineCode parentName="li">{`.gql`}</inlineCode>{` or `}<inlineCode parentName="li">{`.graphql`}</inlineCode>{` file saved on your local machine, or`}</li>
              <li parentName="ul">{`Perform an introspection query on the running service to fetch the schema`}</li>
            </ul>
          </li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Run the `}<inlineCode parentName="p">{`rover subgraph publish`}</inlineCode>{` command, providing your schema in one of the ways shown:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash",
            "metastring": "showLineNumbers=false",
            "showLineNumbers": "false"
          }}>{`# Provide a local .graphql file path
rover subgraph publish my-graph@my-variant --name products --routing-url http://products-graphql.svc.cluster.local:4001/ --schema ./schema.graphql

# Provide an introspection result via stdin
rover subgraph introspect http://localhost:4000 | rover subgraph publish my-graph@my-variant --name products --routing-url http://products-graphql.svc.cluster.local:4001/ --schema -
`}</code></pre>
      </li>
    </ol>
    <p>{`As you register your subgraph schemas, the schema registry attempts to `}<strong parentName="p">{`compose`}</strong>{` their latest versions into a single `}<strong parentName="p">{`supergraph schema`}</strong>{`. Whenever composition succeeds, your gateway can fetch the latest supergraph schema from the registry.`}</p>
    <p>{`You can also fetch your latest supergraph schema with the `}<inlineCode parentName="p">{`rover supergraph fetch`}</inlineCode>{` command, and it's available in GraphOS Studio from your graph's `}<strong parentName="p">{`Schema > SDL`}</strong>{` tab.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      